import { Routes, Route } from "react-router-dom";
import Home from "./screens/home";
import Course from "./screens/coursedetails";
import About from "./screens/about";
import Booking from "./screens/booking";
import Login from "./screens/login";
import Dashboard from "./screens/dashy";
import Coursedetails from "./screens/coursedetailsedit";
import Aboutedit from "./screens/aboutedit.js";
import Bookinglist from "./screens/bookinglist";
import Sectionedit from "./screens/sectionedit";
import Viewsection from "./screens/viewsection";
import Aboutyou from "./screens/aboutyou";
import Legal from "./components/legal";
import Legalview from "./screens/legal";
import Aboutyouedit from "./screens/aboutyouedit.js";
import Subs from "./screens/subscribers";
import Unsubscribe from "./screens/unsubscribe.js";

import { Component } from "react";
import Aos from "aos";
import Landing from "./screens/landing";

class App extends Component {

  componentDidMount() {
    Aos.init();
  }

  render() {
    return (
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="course-details" element={<Course />} />
        <Route path="booking" element={<Booking />} />
        <Route path="about" element={<About />} />
        <Route path="karma" element={<Login />} />
        <Route path="about-you" element={<Aboutyou />} />
        <Route path="view/:uuid" element={<Viewsection />} />
        <Route path="legal/:type" element={<Legalview />} />
        <Route path="dashy" element={<Dashboard />} />
        <Route path="unsubscribe/:unsub" element={<Unsubscribe />} />
        <Route path="download/:duid" element={<Landing />} />
          <Route path="edit">
            <Route index element={<Dashboard />} />
            <Route path="home" element={<Dashboard />} />
            <Route path="course-details" element={<Coursedetails />} />
            <Route path="about" element={<Aboutedit />} />
            <Route path="about-you" element={<Aboutyouedit />} />
            <Route path="booking" element={<Bookinglist />} />
            <Route path="legal/:some" element={<Legal />} />
            <Route path="section/:uuid" element={<Sectionedit />} />
            <Route path="subs" element={<Subs />} />
          </Route>
      </Routes>
    );
  }
}

export default App;
